<template>
  <div class="youtube">
    <iframe src="https://www.youtube.com/embed/DUZ1k7ev2H4?autoplay=1" frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</template>

<script>
import { bus } from '../Bus.js'

export default {
  props: {
    contenitoreHeight: {
      type: Number
    }
  },
  name: 'Youtube',
  i18n: {
    messages: {
      it_IT: {
        youtube: {}
      },
      fr_FR: {
        youtube: {}
      },
      es_ES: {
        youtube: {}
      },
      de_DE: {
        youtube: {}
      },
      en_GB: {
        youtube: {}
      }
    }
  },
  data() {
    return {
    }
  },
  mounted: function () {
  },
  activated: function () {
  },
  deactivated: function () {
  },
  methods: {
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Youtube.vue